// extracted by mini-css-extract-plugin
var _1 = "McpAuthorizeView-module__animateUploadProgressBarWidth--mV_r4";
var _2 = "McpAuthorizeView-module__animatedBackground--Rol5C";
var _3 = "McpAuthorizeView-module__description--D70O9";
var _4 = "McpAuthorizeView-module__email--VfsjW";
var _5 = "McpAuthorizeView-module__host--KpkHe";
var _6 = "McpAuthorizeView-module__loggedIn--OMMU2";
var _7 = "McpAuthorizeView-module__logoContainer--pEISO";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "description", _4 as "email", _5 as "host", _6 as "loggedIn", _7 as "logoContainer" }
